import { api } from './client';

// ── Timeline / report ───────────────────────────────────────────────────────
export interface TimelineItem {
  at: string;
  kind: string;
  title: string;
  body: string | null;
  actor: string | null;
  severity: 'info' | 'warn' | 'critical' | null;
}
export const timelineApi = {
  get: (ticketId: string) =>
    api.get<TimelineItem[]>(`/api/v1/tickets/${ticketId}/timeline`).then(r => r.data),
  /** Скачивает report.md через axios (с JWT), сохраняет файл. */
  downloadReport: async (ticketId: string, ticketNumber: number) => {
    const r = await api.get(`/api/v1/tickets/${ticketId}/report.md`,
                            { responseType: 'blob' });
    const url = URL.createObjectURL(r.data as Blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `sd-${String(ticketNumber).padStart(4, '0')}-report.md`;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  },
};

// ── Extend contract ─────────────────────────────────────────────────────────
export const orgExtraApi = {
  extendContract: (orgId: string, contract_ends_at: string) =>
    api.post(`/api/v1/organizations/${orgId}/extend-contract`,
             { contract_ends_at }).then(r => r.data),
  analytics: (orgId: string, days: number) =>
    api.get(`/api/v1/analytics/organizations/${orgId}`, { params: { days } }).then(r => r.data),
};

// ── FNS lookup ──────────────────────────────────────────────────────────────
export interface FnsResult {
  name: string; full_name: string; inn: string; kpp: string;
  ogrn: string; legal_address: string; director: string | null;
}
export interface FnsSearchHit {
  name: string; full_name: string; inn: string; kpp: string;
  ogrn: string; legal_address: string;
}
export const fnsApi = {
  lookup: (inn: string) =>
    api.get<FnsResult>('/api/v1/integrations/fns/lookup',
                       { params: { inn } }).then(r => r.data),
  search: (q: string, limit = 10) =>
    api.get<FnsSearchHit[]>('/api/v1/integrations/fns/search',
                            { params: { q, limit } }).then(r => r.data),
};

// ── AI send-to-org ──────────────────────────────────────────────────────────
export interface AiSendResult {
  sent_to_tg: boolean;
  sent_to_max: boolean;
  sent_to_ticket: boolean;
  ticket_number?: number | null;
  notes: string[];
}

export const aiSendApi = {
  send: (organization_id: string, text: string,
         opts: { ticket_id?: string; internal?: boolean } = {}) =>
    api.post<AiSendResult>('/api/v1/ai/send-to-org', {
      organization_id, text,
      ticket_id: opts.ticket_id, internal: opts.internal,
    }).then(r => r.data),
};
